"use client";

import { SignIn } from "@clerk/nextjs";
import { useSearchParams } from "next/navigation";

export default function Page() {
  const searchParams = useSearchParams();
  const redirectUrl = searchParams.get("redirect_url");

  // If there's a redirect_url (e.g., from invitation flow), use it
  // Otherwise, default to home
  const finalRedirectUrl = redirectUrl ? decodeURIComponent(redirectUrl) : "/";

  return (
    <div className="flex justify-center items-center py-12">
      <SignIn routing="hash" forceRedirectUrl={finalRedirectUrl} />
    </div>
  );
}
